'use client';

import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';

export default function CategoryFAQ({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  if (!faqs?.length) return null;

  return (
    <section>
      <h2 className="text-lg font-bold text-[#1a1a1a] tracking-[-0.01em] mb-4">
        Preguntas frecuentes
      </h2>
      <div className="space-y-2">
        {faqs.map((faq, i) => (
          <div
            key={i}
            className="rounded-xl border border-gray-200 bg-white/60 overflow-hidden"
          >
            <button
              onClick={() => {
                const isOpening = openIndex !== i;
                setOpenIndex(isOpening ? i : null);
                if (isOpening) trackEvent(EVENTS.CATEGORY_FAQ_EXPANDED, { question: faq.question, position: i });
              }}
              className="w-full flex items-center justify-between px-4 py-3.5 text-left"
            >
              <span className="text-[14px] font-semibold text-[#1a1a1a] pr-4">{faq.question}</span>
              <ChevronDownIcon
                className={`w-3.5 h-3.5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}
              />
            </button>
            {openIndex === i && (
              <div className="px-4 pb-4">
                <p className="text-[13px] text-gray-500 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
